import CompTextField from "./children/CompTextField";
import { CompHTML } from "../widgets/index";

const CompText = ({
	answer_index,
	item_number,
	instant_feedback_bool,
	items_show_explanation_bool,
	items_show_checkanswer_bool,
	validation_js,
	data_js
}) => {
	const { prompt_s, answers_js_a } = data_js;

	var answers_indices_a = [...Array(answers_js_a.length).keys()];
	const text_and_input_items_a = prompt_s
		.replace(/___BLANK___/g, "___SEP______BLANK______SEP___")
		.split("___SEP___");

	return (
		<div style={{ marginTop: 30, lineHeight: 2 }}>
			<span className="prompt">
				<b>{item_number}.</b>{" "}
				{text_and_input_items_a.map((elem, i) => {
					let jsx;
					if (elem === "___BLANK___") {
						// This section builds an input field.
						// Each input uses as its answer-index a zero based digit
						// pulled from the answers_indices_a created from the length of the
						// answers_js_a. Thus, inputs and js can be matched up
						let nested_answer_index = answers_indices_a.shift();
						const answer_js = answers_js_a[nested_answer_index];
						const props_js = {
							answer_index,
							nested_answer_index,
							instant_feedback_bool,
							items_show_explanation_bool,
							items_show_checkanswer_bool,
							answer_js,
							validation_js
						};
						jsx = <CompTextField {...props_js} />;
					} else {
						// This section adds inline text. B/c elem !== "___BLANK___"
						jsx = <CompHTML html={elem} />;
					}
					return <span key={i + 1}>{jsx}</span>;
				})}
			</span>
		</div>
	);
};

export default CompText;

/*

<CompRadios {...props_js} />

const props_js = {
  definitions_js: {
    type: "text"
  },
  validation_js: {
    type: "regex",
    required: "^.+"
  },
  data_js: {
   prompt_s:
   "A casa é ___BLANK___ (branc...) mas ninguem ___BLANK___ (saber).",
 answers_js_a: [
   {
     answer: "branca",
     hint: "Casa is femenine"
   },
   { answer: "sabe", hint: "3sing", explanation: "Bla bla" }
 ]
}
};


*/
